import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const CampaignListing = lazy(() => import("../pages/campaign-listing"));
const CreateCampaign = lazy(() => import("../pages/create-campaign"));
const CampaignDetails = lazy(() => import("../pages/campaign-details"));
const CampaignCalendar = lazy(() => import("../pages/campaign-calendar"));
const CampaignABTesting = lazy(() => import("../pages/campain-ab-testing"));
const CampaignDashboard = lazy(() => import("../pages/campaign-dashboard"));
const CampaignJourney = lazy(() => import("../pages/campaign-journey"));

export const CampaignRouter = [
  {
    path: "campaign",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignListing />
          </Suspense>
        ),
      },
      {
        path: "all/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignListing />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateCampaign />
          </Suspense>
        ),
      },
      {
        path: "edit/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreateCampaign />
          </Suspense>
        ),
      },
      {
        path: "details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignDetails />
          </Suspense>
        ),
      },
      {
        path: "campaign-calendar",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignCalendar />
          </Suspense>
        ),
      },
      {
        path: "campaign-ab-testing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignABTesting />
          </Suspense>
        ),
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignDashboard />
          </Suspense>
        ),
      },
      {
        path: "journey",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CampaignJourney />
          </Suspense>
        ),
      },
    ],
  },
];
